// format the date to display like a caledar icon


import React from 'react';
import moment from 'moment';
import './../../assets/css/dateDisplay.css';

const dateDisplay = (passedDate) => {

let weekday = new Array(7);
weekday[0] =  "Sun";
weekday[1] = "Mon";
weekday[2] = "Tue";
weekday[3] = "Wed";
weekday[4] = "Thu";
weekday[5] = "Fri";
weekday[6] = "Sat";

let monthName = new Array(12);
monthName[0] =  "Jan";
monthName[1] =  "Feb";
monthName[2] =  "Mar";
monthName[3] =  "Apr";
monthName[4] =  "May";
monthName[5] =  "Jun";
monthName[6] =  "Jul";
monthName[7] =  "Aug";
monthName[8] =  "Sep";
monthName[9] =  "Oct";
monthName[10] =  "Nov";
monthName[11] =  "Dec";

    // These are date-only values (requested/scheduled work days). Strip any time
    // or timezone component and anchor at local noon so the display never shifts
    // across midnight (a midnight-UTC value would otherwise render as the prior
    // day). Handles bare "YYYY-MM-DD" and full datetime strings alike.
    let dateStr = passedDate;
    if (typeof passedDate === 'string') {
        const match = passedDate.match(/^(\d{4}-\d{2}-\d{2})/);
        if (match) dateStr = match[1] + 'T12:00:00';
    }
    const date = new Date(dateStr);

    const today = new moment().format("MM/DD/YYYY");
    const formatdate = moment(date).format("MM/DD/YYYY");
    const dayOfWeek = weekday[date.getDay()];
    const daynum = date.getDate();
    const month = monthName[date.getMonth()];


    if (today === formatdate) {
        return (<time dateTime={date} className="icon">
                <strong className="day">{dayOfWeek}</strong>
                <span>{daynum}</span>
                <em>{month}</em>
                </time>)
    } else {
        return (<time dateTime={date} className="icon">
                <strong>{dayOfWeek}</strong>
                <span>{daynum}</span>
                <em>{month}</em>
                </time>)

    }
}

export default dateDisplay;
